import "./Insights.module.css";
import { useLocation } from "react-router-dom";
import Header from "@/reusable_sections/Header";
import InsightsHero from "./sections/InsightsHero";
import InsightAreas from "./sections/InsightAreas";
import StayInformed from "./sections/StayInformed";
import ArticleDetail from "@/pages/InsightArticle/sections/ArticleDetail";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const slug = params.get("slug");
  if (slug) {
    return <div>
        <Header />
        <ArticleDetail />
        <Footer />
      </div>;
  }
  return <div>
      <Header />
      <InsightsHero />
      <InsightAreas />
      <StayInformed />
      <Footer />
    </div>;
}